import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useUpdateProfileMutation } from "../../redux/api/userApi";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import UserLayout from "../../components/layout/UserLayout";

const UpdateProfile = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [CompanyName, setcompnayName] = useState("");
  const [website, setWebsite] = useState("");

  const navigate = useNavigate();

  const [updateProfile, { isLoading, error, isSuccess }] =
    useUpdateProfileMutation();

  const { user } = useSelector((state) => state.auth);

  useEffect(() => {
    if (user) {
      setName(user?.name);
      setEmail(user?.email);
      setPhone(user?.phone);
      setcompnayName(user?.CompanyName);
      setWebsite(user?.website);
    }

    if (error) {
      toast.error(error?.data?.message);
    }

    if (isSuccess) {
      toast.success("User Updated");
      navigate("/me/profile");
    }
  }, [user, error, isSuccess, navigate]);

  const submitHandler = (e) => {
    e.preventDefault();

    const userData = {
      name,
      email,
      phone,
      CompanyName,
      website,
    };

    updateProfile(userData);
  };

  return (
    <UserLayout>
      <div className="flex flex-wrap">
        <div className="w-full lg:w-2/3 px-4">
          <form
            className="shadow-md rounded bg-white p-4"
            onSubmit={submitHandler}
          >
            <h2 className="text-2xl font-semibold mb-4 text-center">
              {" "}
              Update Profile{" "}
            </h2>

            <div className="mb-3">
              <label
                htmlFor="name_field"
                className="block text-gray-700 text-sm font-bold mb-2"
              >
                {" "}
                Name{" "}
              </label>
              <input
                type="text"
                id="name_field"
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                name="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>

            <div className="mb-3">
              <label
                htmlFor="email_field"
                className="block text-gray-700 text-sm font-bold mb-2"
              >
                {" "}
                Email{" "}
              </label>
              <input
                type="email"
                id="email_field"
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className="mb-3">
              <label className="block text-gray-700 text-sm font-bold mb-2">
                Phone Number
              </label>
              <input
                type="text"
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                name="phone"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />
            </div>
            <div className="mb-3">
              <label className="block text-gray-700 text-sm font-bold mb-2">
                Company Name
              </label>
              <input
                type="text"
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                name="companyName"
                value={CompanyName}
                onChange={(e) => setcompnayName(e.target.value)}
              />
            </div>
            <div className="mb-3">
              <label className="block text-gray-700 text-sm font-bold mb-2">
                Website
              </label>
              <input
                type="text"
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                name="website"
                value={website}
                onChange={(e) => setWebsite(e.target.value)}
              />
            </div>

            <button
              type="submit"
              className={`w-full ${
                isLoading ? "bg-gray-500" : "bg-blue-500 hover:bg-blue-700"
              } text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline`}
              disabled={isLoading}
            >
              {isLoading ? <i className="fa fa-spinner fa-spin"></i> : "Update"}
            </button>
          </form>
        </div>
      </div>
    </UserLayout>
  );
};

export default UpdateProfile;
